export enum UserDeleteDialogState {
    Closed = 'Closed',
    DeletionOfUserWithNoAssets = 'DeletionOfUserWithNoAssets',
    AssetValidation = 'AssetValidation',
    TransferAssets = 'TransferAssets',

    AssetValidationFail = 'AssetValidationFail',
    TransferAssetsFail = 'TransferAssetsFail',
    DeleteFail = 'DeleteFail',
}
